import { apiClient } from './apiClient';

export type BillingType = {
  id: number;
  name: string;
};

type BillingTypeResponse = {
  results: BillingType[];
};

export const getBillingTypes = (): Promise<BillingTypeResponse> => {
  return apiClient.get(`/billing-types`, {});
};
